import { render, staticRenderFns } from "./awardNotice.vue?vue&type=template&id=335175e5&scoped=true&"
import script from "./awardNotice.vue?vue&type=script&lang=js&"
export * from "./awardNotice.vue?vue&type=script&lang=js&"
import style0 from "./awardNotice.vue?vue&type=style&index=0&id=335175e5&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "335175e5",
  null
  
)

export default component.exports